<template>
  <div class="c-grid-controls">
    <div class="c-grid-controls__column c-grid-controls__column--static" style="min-width:80px">
      <div class="c-grid-controls__column__inner">
        
      </div>
    </div>
      <Draggable
        class="draggable"
        v-model="currentGridColumns"
        group="index"
        @start="drag=true"
        @end="onChange"
        >
      <div
        class="c-grid-controls__column"
        v-for="(column, index) in currentGridColumns"
        :style="'width:' + column.width + 'px'"
        :key="index"
      >
        <div
          class="c-grid-controls__column__inner"
          v-if="column.key === 'bucket'"
        >
          Bucket
        </div>
        <div
          class="c-grid-controls__column__inner"
          v-if="column.key === 'folder'"
        >
          Folder
        </div>
        <div
          class="c-grid-controls__column__inner"
          v-if="column.key === 'date'"
        >
          Date
        </div>
        <div
          class="c-grid-controls__column__inner"
          v-if="column.key === 'text'"
        >
          Text
        </div>
        <div
          class="c-grid-controls__column__inner"
          v-if="column.key === 'comment'"
        >
          Comment
        </div>
        <div
          class="c-grid-controls__column__inner"
          v-if="column.key === 'controls'"
        >
          Actions
        </div>
        </div>
      </Draggable>
    </div>
  </div>
</template>

<script>
import TextRenderer from "@/components/dashboard/text-renderer";
import moment from "moment";
import { MoreVerticalIcon, CheckIcon } from "vue-feather-icons";
import Draggable from "vuedraggable";

export default {
  components: {
    Draggable,
    MoreVerticalIcon,
    CheckIcon,
    TextRenderer,
  },
  data: function () {
    return {
      currentGridColumns: [],
    };
  },
  props: ["note", "gridColumns"],
  watch: {
    gridColumns: {
      handler: function () {
        if (this.gridColumns) {
          this.currentGridColumns = this.gridColumns;
        }
      },
      immediate: true,
    },
  },
  computed: {
    computedGridColumns: function () {
      let columns = this.gridColumns;
      return columns;
    },
  },
  methods: {
    onChange: function (e) {
      console.log(e);
      this.currentGridColumns = this.currentGridColumns.map((col, i) => {
        console.log(col.key + " " + col.index);
        col.index = i;
        return col;
      });
      console.log("--------");
      this.$store.dispatch(
        "dashboard/updateGridColumns",
        this.currentGridColumns
      );
    },
  },
};
</script>

<style lang="scss">
.c-grid-controls {
  display: flex;
  &__column {
    border-right: var(--g3) solid 1px;
    //background-color: var(--p4);

    &__inner {
      height: 100%;
      display: flex;
      justify-content: center;
      border-top: var(--g3) solid 1px;
      border-bottom: var(--g3) solid 1px;
      padding: $lg-margins $lg-margins * 2;
      background-color: var(--g4);
    }

    &--static {
      border-right: var(--g2) solid 1px;

      .c-grid-controls__column__inner {
        border-color: transparent;
      }
    }
  }

  &__text {
    display: inline-block;
    padding: $lg-margins $lg-margins * 2;
    font-size: var(--font-size-xs);
  }

  &__article {
    width: 100%;
    display: inline-block;
    padding: $lg-margins $lg-margins * 2;
    opacity: 0.85;
  }

  &__block {
    padding: $lg-margins $lg-margins * 2;
  }

  &__dragger {
    position: relative;
    margin-top: 3px;
    width: 24px;
    height: 24px;
    opacity: 0.8;
    transition: opacity 50ms linear;
    cursor: grab;
    svg {
      position: absolute;
      top: calc(50% - 8px);
      left: 0;
      display: inline-block;

      &:last-child {
        left: 6px;
      }
    }

    &:hover,
    &:active {
      opacity: 1;
    }
  }

  .draggable {
    display: flex;
  }

  .c-text-renderer {
    width: 100%;
  }
}
</style>